import { useState } from 'react';
import AnnouncementBar from '../home/components/AnnouncementBar';
import Navbar from '../home/components/Navbar';
import FooterSection from '../home/components/FooterSection';
import SEOHead from '../../components/feature/SEOHead';
import { SITE_URL } from '../../utils/seo';

const costBenefits = [
  { icon: 'ri-money-dollar-circle-line', title: 'Lisanslama Ücretlerini Önemli Ölçüde Azaltın', desc: 'Ön lisanslama ücretleri %50 veya daha fazla azaltılır ve sahip olma toplam maliyetinde 3X veya daha fazla tasarruf yaygındır.' },
  { icon: 'ri-server-line', title: 'Altyapı Maliyetlerini Azaltın', desc: 'VergeOS ve Inuvika OVD yüksek verimlidir ve mevcut donanımda daha iyi performans sunar.' },
  { icon: 'ri-close-circle-line', title: 'Gereksiz Yazılım Maliyetlerinden Kaçının', desc: 'Inuvika OVD, Microsoft SQL gibi Windows Sunucu tabanlı bileşenler gerektirmez. VergeOS harici depolama ve özel ağ donanımı ihtiyacını ortadan kaldırır.' },
];

const deliveryBenefits = [
  'Saniyeler içinde yüzlerce masaüstü başlatın — RAID darboğazı veya vSAN verimsizliği yok',
  'Windows ve Linux uygulamalarını verimli bir şekilde teslim edin — ek yük veya lisanslama maliyeti olmadan',
  'Giriş gecikmelerini azaltın ve önyükleme fırtınalarını ortadan kaldırın — VergeFS depolama performansını hızlandırır ve dayanıklılığı artırır',
];

const managementBenefits = [
  'Tüm altyapı işlevleri ve VDI için tek sezgisel arayüz ile karmaşık çoklu konsol yönetimi yok',
  'Kalıcı ve kalıcı olmayan masaüstleri için esnek dağıtım',
  'Çok faktörlü kimlik doğrulama, oturum kilidi ve veri şifreleme ile yerleşik güvenlik ve uyumluluk',
];

const faqList = [
  { q: 'VergeIO ve Inuvika çözümü nedir?', a: 'VergeIO ve Inuvika çözümü tam entegre sanal masaüstü ve uygulama teslim platformudur. VergeOS\'un verimli altyapısını Inuvika OVD\'nin akıcı uygulama sanallaştırmasıyla birleştirerek daha hızlı, daha uygun maliyetli ve yönetimi kolay bir alternatif sunar.' },
  { q: 'Maliyetleri nasıl azaltır?', a: 'Lisanslama maliyetleri %50 veya daha fazla azaltılır. VergeOS mevcut donanımda çalışırken Inuvika OVD, Microsoft SQL gibi pahalı Windows Sunucu bileşenlerine olan bağımlılığı ortadan kaldırır.' },
  { q: 'Çözüm hangi tür sanal masaüstlerini ve uygulamaları destekler?', a: 'Hem kalıcı hem de kalıcı olmayan masaüstleri desteklenir. Windows ve Linux uygulamalarının teslimi ek lisanslama maliyeti olmadan mümkündür. HTML5 web tarayıcısı olan herhangi bir cihazdan erişilebilir.' },
  { q: 'Bu çözüm geleneksel VDI\'ye kıyasla performansı nasıl iyileştirir?', a: 'VergeFS, RAID darboğazlarını ve vSAN verimsizliklerini ortadan kaldırarak depolama performansını hızlandırır. Sonuç olarak masaüstleri saniyeler içinde başlatılır ve giriş gecikmeleri önemli ölçüde azaltılır.' },
  { q: 'Bu çözüm yönetimi kolaylaştırır mı?', a: 'Evet. Tüm altyapı ve VDI için tek, sezgisel yönetim arayüzü sunulur. Çoklu konsol veya birden fazla yönetim aracına gerek yoktur.' },
  { q: 'Çözüm uzak çalışanları ve hibrit bulut ortamlarını destekler mi?', a: 'Evet. VDI ortamı HTML5 web tarayıcısı olan herhangi bir cihazdan erişilebilir ve hibrit bulut stratejileriyle sorunsuz entegre olur.' },
  { q: 'Hangi güvenlik özellikleri dahildir?', a: 'Çok faktörlü kimlik doğrulama, oturum kilidi ve veri şifreleme yerleşik olarak sunulur. VergeOS\'un sertleştirilmiş ortamı ek güvenlik katmanı sağlar.' },
  { q: 'Bu çözüm depolama yoğun iş yüklerini nasıl yönetir?', a: 'VergeFS, VergeOS\'a entegre vSAN olarak depolama yoğun iş yükleri için optimize edilmiş depolama altyapısı sunar. Global satır içi tekilleştirme ile depolama ihtiyaçları önemli ölçüde azaltılır.' },
];

const vdiJsonLd = { '@context': 'https://schema.org', '@type': 'SoftwareApplication', name: 'VergeOS VDI', applicationCategory: 'BusinessApplication', operatingSystem: 'Any', description: 'VergeOS ile maliyet etkin sanal masaüstü altyapısı. Yüksek kullanıcı yoğunluğu, hızlı sağlama ve merkezi yönetim.', url: `${SITE_URL}/virtual-desktop` };

const vdiFaqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    { '@type': 'Question', name: 'VergeIO ve Inuvika çözümü nedir?', acceptedAnswer: { '@type': 'Answer', text: 'VergeIO ve Inuvika çözümü tam entegre sanal masaüstü ve uygulama teslim platformudur. VergeOS\'un verimli altyapısını Inuvika OVD\'nin akıcı uygulama sanallaştırmasıyla birleştirerek daha hızlı, daha uygun maliyetli ve yönetimi kolay bir alternatif sunar.' } },
    { '@type': 'Question', name: 'VDI maliyetleri nasıl azaltılır?', acceptedAnswer: { '@type': 'Answer', text: 'Lisanslama maliyetleri %50 veya daha fazla azaltılır. VergeOS mevcut donanımda çalışırken Inuvika OVD, Microsoft SQL gibi pahalı Windows Sunucu bileşenlerine olan bağımlılığı ortadan kaldırır.' } },
    { '@type': 'Question', name: 'Bu çözüm yönetimi kolaylaştırır mı?', acceptedAnswer: { '@type': 'Answer', text: 'Evet. Tüm altyapı ve VDI için tek, sezgisel yönetim arayüzü sunulur. Çoklu konsol veya birden fazla yönetim aracına gerek yoktur.' } },
    { '@type': 'Question', name: 'Hangi güvenlik özellikleri dahildir?', acceptedAnswer: { '@type': 'Answer', text: "Çok faktörlü kimlik doğrulama, oturum kilidi ve veri şifreleme yerleşik olarak sunulur. VergeOS'un sertleştirilmiş ortamı ek güvenlik katmanı sağlar." } },
    { '@type': 'Question', name: 'Çözüm uzak çalışanları destekler mi?', acceptedAnswer: { '@type': 'Answer', text: 'Evet. VDI ortamı HTML5 web tarayıcısı olan herhangi bir cihazdan erişilebilir ve hibrit bulut stratejileriyle sorunsuz entegre olur.' } },
    { '@type': 'Question', name: 'Bu çözüm geleneksel VDI\'ye kıyasla performansı nasıl iyileştirir?', acceptedAnswer: { '@type': 'Answer', text: 'VergeFS, RAID darboğazlarını ve vSAN verimsizliklerini ortadan kaldırarak depolama performansını hızlandırır. Sonuç olarak masaüstleri saniyeler içinde başlatılır ve giriş gecikmeleri önemli ölçüde azaltılır.' } },
  ],
};

export default function VirtualDesktopPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  return (
    <div className="min-h-screen w-full bg-white">
      <SEOHead title="Sanal Masaüstü (VDI) | VergeOS Masaüstü Sanallaştırma" description="VergeOS ile maliyet etkin sanal masaüstü altyapısı (VDI). Yüksek kullanıcı yoğunluğu, hızlı sağlama ve merkezi yönetim." keywords="sanal masaüstü, VDI, virtual desktop, VergeOS, masaüstü sanallaştırma, uzaktan çalışma" canonicalPath="/virtual-desktop" jsonLd={[vdiJsonLd, vdiFaqJsonLd]} />
      <AnnouncementBar />
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative w-full overflow-hidden bg-[#0f1117] py-24 text-center">
          <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'repeating-linear-gradient(45deg,#e8600a 0,#e8600a 1px,transparent 0,transparent 50%)', backgroundSize: '20px 20px' }} />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0f1117]/60 to-[#0f1117]/90" />
          <div className="relative z-10 max-w-4xl mx-auto px-6">
            <div className="inline-block bg-[#e8600a]/20 text-[#e8600a] text-xs font-semibold uppercase tracking-widest px-4 py-1.5 rounded-full mb-6">BT Girişimleri</div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 leading-tight">
              VergeIO ve <span className="text-[#e8600a]">Inuvika</span>
            </h1>
            <p className="text-xl text-gray-300 mb-3 font-medium">Hızlı, Ekonomik Alternatif</p>
            <p className="text-gray-400 text-sm mb-8 max-w-2xl mx-auto">VDI maliyetlerini yarıya indirin. Performansı artırın. Yönetimi basitleştirin.</p>
          </div>
        </section>

        {/* Intro */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">Performanstan Ödün Vermeden Düşük Maliyetli VDI</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">sSanal masaüstü altyapısına (VDI) ve uygulama teslimine dayanan kuruluşlar, artan lisanslama maliyetleri, artan karmaşıklık ve büyüyen performans sorunlarıyla karşılaşmaktadır. VergeIO ve Inuvika'nın ortak çözümü daha hızlı, daha basit ve çok daha ekonomik bir alternatif sunar.</p>
                <div className="flex gap-8">
                  <div className="flex flex-col items-center gap-2">
                    <div className="w-20 h-20 flex items-center justify-center bg-[#f8fafc] rounded-xl border border-gray-200">
                      <span className="text-2xl font-bold text-[#e8600a]">Inuvika</span>
                    </div>
                    <p className="text-xs text-gray-500 text-center">Apps + Desktops</p>
                  </div>
                  <div className="flex items-center text-gray-400 text-2xl font-bold">+</div>
                  <div className="flex flex-col items-center gap-2">
                    <div className="w-20 h-20 flex items-center justify-center bg-[#f8fafc] rounded-xl border border-gray-200">
                      <span className="text-xl font-bold text-[#1e293b]">verge<span className="text-[#e8600a]">.io</span></span>
                    </div>
                    <p className="text-xs text-gray-500 text-center">Altyapı OS</p>
                  </div>
                </div>
              </div>
              <div className="rounded-xl overflow-hidden">
                <img src="https://public.readdy.ai/ai/img_res/c4ca99eb7e7f0583fff585fe31e1cef9.jpg" alt="VDI Mimarisi" className="w-full h-full object-top" />
              </div>
            </div>
          </div>
        </section>

        {/* Cost Benefits */}
        <section className="py-20 bg-[#f8fafc]">
          <div className="max-w-6xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-[#1e293b] text-center mb-12">Performanstan Ödün Vermeden Düşük Maliyetler</h2>
            <div className="grid md:grid-cols-3 gap-6">
              {costBenefits.map(b => (
                <div key={b.title} className="bg-white rounded-lg border border-gray-100 p-6">
                  <span className="w-10 h-10 flex items-center justify-center bg-[#e8600a]/10 rounded-lg text-[#e8600a] mb-4"><i className={`${b.icon} text-xl`}></i></span>
                  <h3 className="font-semibold text-[#1e293b] mb-2 text-sm">{b.title}</h3>
                  <p className="text-xs text-gray-600 leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Delivery & Management */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-12">
              <div>
                <h2 className="text-2xl font-bold text-[#1e293b] mb-6">Daha Hızlı Sanal Masaüstü ve Uygulama Teslimi</h2>
                <ul className="space-y-3">
                  {deliveryBenefits.map(item => (
                    <li key={item} className="flex items-start gap-2 text-sm text-gray-700">
                      <i className="ri-check-line text-[#e8600a] text-base shrink-0 mt-0.5"></i>{item}
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h2 className="text-2xl font-bold text-[#1e293b] mb-6">Basitleştirilmiş VDI Yönetimi ve Ölçeklenebilirlik</h2>
                <ul className="space-y-3">
                  {managementBenefits.map(item => (
                    <li key={item} className="flex items-start gap-2 text-sm text-gray-700">
                      <i className="ri-check-line text-[#e8600a] text-base shrink-0 mt-0.5"></i>{item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-20 bg-white border-t border-gray-200">
          <div className="max-w-3xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-[#1e293b] text-center mb-12">VDI Alternatifi SSS</h2>
            <div className="space-y-4">
              {faqList.map((faq, i) => (
                <div key={i} className="bg-gray-50 rounded-lg border border-gray-100 overflow-hidden">
                  <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer">
                    <span className="font-medium text-[#1e293b] text-sm">{faq.q}</span>
                    <span className="w-5 h-5 flex items-center justify-center text-gray-400 shrink-0"><i className={`${openFaq === i ? 'ri-subtract-line' : 'ri-add-line'} text-lg`}></i></span>
                  </button>
                  {openFaq === i && <div className="px-6 pb-5 text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-4">{faq.a}</div>}
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <FooterSection />
    </div>
  );
}
